<template>
    <div class="form-edit-page row row-space">
        <div class="form-item-char10">
            <label class="label-caption">Código</label>
            <div class="field-label field-label-end">{{ usuario.cdusuario }}</div>
        </div>

        <div class="form-item">
            <label class="label-caption">Nome</label>
            <div class="field-label">{{ usuario.nmusuario }}</div>
        </div>

        <button class="btn-small" :disabled="isSaving" @click="salvar">{{ isSaving ? 'Salvando...' : 'Salvar' }}</button>
        <button class="btn-small" @click="closeForm">Sair</button>
    </div>



    <!-- Alert -->
    <div v-if="msg" class="msg">{{ msg }}</div>

    <div class="cards-grid">
        <!-- AGRICULTURA -->
        <section class="card">
            <div class="card-title">
                <span>AGRICULTURA</span>
                <ToggleSN v-model="perfil.agr_acesso" />
            </div>

            <div v-if="perfil.agr_acesso === 1" class="subopts">
                <div class="subrow">
                    <span>Cadastro</span>
                    <ToggleSN v-model="perfil.agr_cadastro" />
                </div>
                <div class="subrow">
                    <span>Gestor</span>
                    <ToggleSN v-model="perfil.agr_gestor" />
                </div>
                <div class="subrow">
                    <span>Recadastramento</span>
                    <ToggleSN v-model="perfil.agr_recadastramento" />
                </div>
            </div>
        </section>


        <!-- ALMOXARIFADO -->
        <section class="card">
            <div class="card-title">
                <span>ALMOXARIFADO</span>
                <ToggleSN v-model="perfil.almox_acesso" />
            </div>
            <p class="hint" v-if="perfil.almox_acesso === 1">
                Acesso liberado ao módulo (sem perfis internos por enquanto).
            </p>
        </section>


        <!-- FROTA -->
        <section class="card">
            <div class="card-title">
                <span>FROTA</span>
                <ToggleSN v-model="perfil.frota_acesso" />
            </div>
            <p class="hint" v-if="perfil.frota_acesso === 1">
                Acesso liberado ao módulo (sem perfis internos por enquanto).
            </p>
        </section>


        <!-- GABINETE -->
        <section class="card">
            <div class="card-title">
                <span>GABINETE</span>
                <ToggleSN v-model="perfil.gab_acesso" />
            </div>

            <div v-if="perfil.gab_acesso === 1" class="subopts">
                <div class="subrow">
                    <span>Gestor</span>
                    <ToggleSN v-model="perfil.gab_gestor" />
                </div>
                <div class="subrow">
                    <span>Recepção</span>
                    <ToggleSN v-model="perfil.gab_recepcao" />
                </div>
                <div class="subrow">
                    <span>SU / Admin</span>
                    <ToggleSN v-model="perfil.gab_su" />
                </div>
            </div>
        </section>


        <!-- ILUMINAÇÃO PÚBLICA -->
        <section class="card">
            <div class="card-title">
                <span>ILUMINAÇÃO PÚBLICA</span>
                <ToggleSN v-model="perfil.ip_acesso" />
            </div>
            <p class="hint" v-if="perfil.ip_acesso === 1">
                Acesso liberado ao módulo (sem perfis internos por enquanto).
            </p>
        </section>


        <!-- OBRAS -->
        <section class="card">
            <div class="card-title">
                <span>OBRAS</span>
                <ToggleSN v-model="perfil.obras_acesso" />
            </div>
            <p class="hint" v-if="perfil.obras_acesso === 1">
                Acesso liberado ao módulo (sem perfis internos por enquanto).
            </p>
        </section>
    </div>
</template>

<script setup>
import { reactive, ref, onMounted, watch } from 'vue'
import { Api } from '@/funcoes/apiExport';
import ToggleSN from '@/components/ToggleSN.vue';

const emit = defineEmits(['close','save'])

const props = defineProps({
    usuario: { type: Object, required: true }
})

const isSaving = ref(false)
const msg = ref('')

const perfil = reactive({
    id: 0,
    agr_acesso: 0,
    agr_cadastro: 0,
    agr_gestor: 0,
    agr_recadastramento: 0,
    almox_acesso: 0,
    frota_acesso: 0,
    gab_acesso: 0,
    gab_gestor: 0,
    gab_recepcao: 0,
    gab_su: 0,
    ip_acesso: 0,
    obras_acesso: 0,
    idlogin: 0
})


// se desmarcar o módulo principal, zera subopções
watch(() => perfil.agr_acesso, (v) => {
    if (v !== 1) {
        perfil.agr_cadastro = 0
        perfil.agr_gestor = 0
        perfil.agr_recadastramento = 0
    }
})


watch(() => perfil.gab_acesso, (v) => {
    if (v !== 1) {
        perfil.gab_gestor = 0
        perfil.gab_recepcao = 0
        perfil.gab_su = 0
    }
})


// opcional: se marcar subopção, garante o principal ligado
watch(() => [perfil.agr_cadastro, perfil.agr_gestor, perfil.agr_recadastramento], (arr) => {
    if (arr.some(x => x === 1)) perfil.agr_acesso = 1
})


watch(() => [perfil.gab_gestor, perfil.gab_recepcao, perfil.gab_su], (arr) => {
    if (arr.some(x => x === 1)) perfil.gab_acesso = 1
})


async function carregar() {
    try{
        msg.value=null
        const data = await Api.getCadastroById('usuario_perfil', props.usuario.id)
        if (data) {
            Object.assign(perfil, data[0])
        } else {
            msg.value = 'Não foi possível acessa os dados para edição'
        }
    } catch (error) {msg.value = error}
}


function closeForm(){emit('close')}


async function salvar() {
    try {
        isSaving.value = true
        msg.value = ''
        
        const response      = await Api.genericPut('/cad/usuario_perfil', perfil);
        if (response.bolok === 1){
            emit('salvo');
            emit('close');
        }else{
            msg.value = response.erro;
        }
    } catch (e) {
        msg.value = (e?.message ?? 'Erro ao salvar liberações.')
    } finally {
        isSaving.value = false
    }
}

onMounted(carregar)
</script>

<script>
export default {
    components: {
        ToggleSN: {
            props: { modelValue: { type: Number, default: 0 } },
            emits: ['update:modelValue'],
            computed: {
                isOn: {
                    get() { return this.modelValue === 1 },
                    set(v) { this.$emit('update:modelValue', v ? 1 : 0) }
                }
            },
            template: `
                <button type="button"
                    class="toggle"
                    :class="{ on: isOn }"
                    @click="isOn = !isOn"
                    :title="isOn ? 'SIM' : 'NÃO'">
                    <span class="dot"></span>
                    <span class="lbl">{{ isOn ? 'SIM' : 'NÃO' }}</span>
                </button>
            `
        }
    }
}
</script>

<style scoped>
.perfil-page { padding: 12px; }

.perfil-header{
    display:flex; align-items:flex-end; justify-content:space-between;
    gap: 12px; padding: 12px;
    border: 1px solid #e6e6e6; border-radius: 10px;
    background: #fff;
    margin-bottom: 12px;
}
.header-left{ display:flex; gap: 12px; width: 100%; }
.grow{ flex: 1; }
.field { min-width: 140px; }

.btn-primary{
    padding: 10px 14px; border-radius: 10px; border: 0;
    background: #1f6feb; color: #fff; cursor: pointer;
}
.btn-primary:disabled{ opacity: .6; cursor: not-allowed; }

.msg{
    border: 1px solid #e6e6e6; background:#fff;
    padding: 10px 12px; border-radius: 10px;
    margin-bottom: 12px;
}

.cards-grid{
    display:grid;
    grid-template-columns: repeat(2, minmax(280px, 1fr));
    gap: 12px;
}
@media (max-width: 900px){
  .cards-grid{ grid-template-columns: 1fr; }
}

.card{
    border: 1px solid #e6e6e6; border-radius: 12px;
    background: #fff; padding: 12px;
}
.card-title{
    display:flex; align-items:center; justify-content:space-between;
    gap: 10px; font-weight: 700;
}
.subopts{ margin-top: 10px; padding-top: 10px; border-top: 1px dashed #e6e6e6; }
.subrow{
    display:flex; align-items:center; justify-content:space-between;
    padding: 8px 0;
}
.hint{ margin: 10px 0 0; font-size: 12px; opacity: .75; }

.toggle{
    display:flex; align-items:center; gap: 8px;
    border: 1px solid #e6e6e6; border-radius: 999px;
    padding: 6px 10px; background: #fafafa; cursor:pointer;
}
.toggle .dot{
    width: 10px; height: 10px; border-radius: 50%;
    background: #999;
}
.toggle.on{ background:#eaf2ff; border-color:#cfe0ff; }
.toggle.on .dot{ background:#1f6feb; }
.toggle .lbl{ font-size: 12px; font-weight: 700; }
</style>
